
import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/Login.vue'
import DormGroup from '@/views/DormGroup.vue'
import TerminalStatus from '@/views/TerminalStatus.vue'
import AlarmRecords from '@/views/AlarmRecords.vue'
import ModifyTerminal from '@/views/ModifyTerminal.vue'
import TerminalOperation from '@/views/TerminalOperation.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/',
      name: 'DormGroup',
      component: DormGroup,
      meta: { requiresAuth: true }
    },
    {
  path: '/terminal/modify',
  name: 'ModifyTerminal',
  component: ModifyTerminal,
  props: true,
  meta: { requiresAuth: true }
},
    {
      path: '/terminal/:dormId',
      name: 'TerminalStatus',
      component: TerminalStatus,
      props: true,
      meta: { requiresAuth: true }
    },
  
 {
  path: '/operation/:deviceId',
  name: 'TerminalOperation',
  component: TerminalOperation,
  props: route => ({ deviceId: route.params.deviceId }),
  meta: { requiresAuth: true }
},


    {
      path: '/alarms/:dormId?',
      name: 'AlarmRecords',
      component: AlarmRecords,
      props: true,
      meta: { requiresAuth: true }
    },
    
    {
      path: '*',
      redirect: '/login'
    }
  ]
})

router.beforeEach((to, from, next) => {

  // 允许 mp4 资源
  if (/^\/mp4\/.*\.(mp4|webm|ogg)$/i.test(to.path)) {
    return next()
  }

  // 获取 URL token
  const urlToken = to.query.token

  // 如果 URL 上带 token，就存起来
  if (urlToken) {
    localStorage.setItem('token', urlToken)

     // 清掉 URL 的 token
  next({ path: to.path, query: {} })
  return
  }

  const token = localStorage.getItem('token')

  if (to.name === 'Login') {
    if (token) {
      next({ name: 'DormGroup' })
    } else {
      next()
    }
  } 
  else if (to.matched.some(r => r.meta.requiresAuth)) {

    if (token) {
      next()
    } else {
      next({ name: 'Login' })
    }

  } 
  else {
    next()
  }

})



export default router
